<template>
    <!--
        Formulario de Alta Baja y Modificacion de telefonos

        En caso de modificacion, itemSelected contiene el elemento y
        en caso de alta se debe cargar itemDataSelected.

    -->
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form @submit.prevent="submit">
                <v-row>
                    <v-col cols="12" md="3">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete dense v-model.number="itemDataSelected.codpais" label="Cod. Pais"
                                item-value="prefijo" :error-messages="v.errors[0]" @input="selectCodPais" return-object
                                :item-text="item => `(+${item.prefijo})  ${item.nombre}`"
                                :items="codigoPais"></v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="5" md="3">
                        <ValidationProvider rules="required|minmax:2,4|numeric" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.carac" prefix="0-" hide-spin-buttons
                                type="number" @keydown="preventArrowKeys" label="Prefijo sin 0"
                                :error-messages="v.errors[0]">
                            </v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="7" md="6">
                        <ValidationProvider :rules="getRules" v-slot="v">
                            <v-text-field dense v-model="itemDataSelected.telefono" hide-spin-buttons type="number"
                                autocomplete="off" @keydown="preventArrowKeys" :error-messages="v.errors[0]"
                                label="Número" :prefix="(itemDataSelected.tiptelefono == 2) ? '15-' : ''">>
                            </v-text-field>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-select dense v-model="itemDataSelected.tipcontacto" :items="tipoContacto" return-object
                                @input="selectTipoContTel" item-text="tcnt_des_tipcontacto"
                                :error-messages="v.errors[0]" item-value="tcnt_id" label="Tipo de contacto">
                            </v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="6">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-select dense v-model="itemDataSelected.tiptelefono" :items="tipoTelefono"
                                @change="onChangeTipTel" @input="selectTipoTelefono" label="Tipo de Telefono"
                                item-value="id" return-object :error-messages="v.errors[0]"
                                item-text="ttel_destelefono">
                            </v-select>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12">
                        <ValidationProvider :rules="{}" v-slot="v">
                            <v-checkbox v-model.number="itemDataSelected.recibellamada" :true-value=1 :false-value=0
                                color="primary" label="Marcar como contacto principal." hide-details
                                :readonly="(initialRecibeLlamada)">
                                <template v-slot:label>
                                    <div
                                        :class="(itemDataSelected.recibellamada) ? `font-weight-medium primary--text` : `dark--text font-weight`">
                                        Marcar como medio de contacto principal.
                                    </div>
                                </template>
                            </v-checkbox>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-end">
                        <v-btn elevation="0" color="primary" :disabled="invalid" class="pa-5" type="submit">
                            <v-icon class="mr-1">mdi-phone-plus-outline</v-icon>
                            Guardar cambios
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Alertas from '@/components/alerts/Alertas.vue'
import { mapActions, mapGetters } from 'vuex';
import { readonly } from 'vue';

export default {
    components:
    {
        ValidationProvider,
        ValidationObserver,
        Alertas
    },
    data() {
        return {

            itemDataSelected: {
                id: '',
                nroafi: '',
                idcarrier: 1,
                idpais: 10,
                codpais: 54,
                carac: '',
                telefono: '',
                tiptelefono: '',
                recibellamada: '',
                tipcontacto: '',
                destipcontacto: '',
                destipcarrier: '',
                destiptelefono: '',
            },
            // f_tipoContacto: [],
            modificado: false,
            initialRecibeLlamada: '',
            initialDesTipContacto: ''
        }
    },
    mounted() {
        if (this.accion == 'modificar') {
            this.itemDataSelected = { ...this.itemSelected, accion: 'M' }
            this.initialRecibeLlamada = this.itemDataSelected.recibellamada
        } else {
            this.itemDataSelected = {
                id: '',
                nroafi: '',
                idcarrier: 1,
                idpais: 10,
                codpais: 54,
                carac: '',
                telefono: '',
                tiptelefono: '',
                recibellamada: 0,
                tipcontacto: '',
                destipcontacto: '',
                destipcarrier: '',
                destiptelefono: '',
                accion: 'A'
            }
        }
        this.getTipoTelefono({ datoComun: 'obtenerTiposTelefono' })

        /*   if (this.titulo.includes('Editar')) {
              //filtro por tipoContacto
              //this.f_tipoContacto = this.itemDataSelected.filters(e => e.tipoContacto)
              this.itemDataSelected = Object.assign({}, this.itemSelected)
              this.initialRecibeLlamada = this.itemDataSelected.recibellamada
              this.initialDesTipContacto = this.itemDataSelected.destipcontacto
              this.modificado = true
  
          } else {
              this.itemDataSelected = {
                  id: '',
                  nroafi: '',
                  idcarrier: '',
                  idpais: 10,
                  codpais: 54,
                  carac: '',
                  telefono: '',
                  tiptelefono: '',
                  recibellamada: 0,
                  tipcontacto: '',
                  destipcontacto: '',
                  destipcarrier: '',
                  destiptelefono: '',
              }
              this.modificado = false
              this.initialDesTipContacto = ''
              this.initialRecibeLlamada = '' 
          }
          */
    },
    created() {
    },
    computed: {
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('common', ['tipoCarrier', 'tipoContacto', 'codigoPais', 'tipoTelefono']),
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters(['telefono', 'hayTelefonoPrinc', 'telefonoPrinc']),

        tipoContactoFiltrado() {
            return this.tipoContacto.filter(item => !this.tipoContactoFiltro.includes(item.tcnt_des_tipcontacto))
        },
        getRules() {
            if (this.itemDataSelected.codpais == 54) return { required: true, numeric: true, validPhone: { caracteristica: this.itemDataSelected.carac } }
            else return { required: true, numeric: true }
        }
    },

    methods: {
        ...mapActions('common', ['getTipoTelefono']),
        ...mapActions(['sendTelefono', 'refreshData']),
        ...mapActions('notificaciones', ['showSnack']),

        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },

        //** Metodos para telefonos */
        selectCodPais(value) {
            this.itemDataSelected.idpais = value.id
            this.itemDataSelected.codpais = value.prefijo
            //this.itemDataSelected.recibellamada = 1
        },
        selectTipoTelefono(value) {
            this.itemDataSelected.tiptelefono = value.id
            this.itemDataSelected.destiptelefono = value.ttel_destelefono
        },

        selectTipoContTel(value) {
            const tipoSeleccionado = value.tcnt_des_tipcontacto;
            // Verifica si ya existe ese tipo de contacto en otro teléfono (excluyendo el actual)
            const existe = this.telefono.some(
                t => t.destipcontacto === tipoSeleccionado && t.id !== this.itemDataSelected.id
            );
            if (existe) {
                this.showSnack({
                    message: `Ya existe el tipo ${tipoSeleccionado} que quiere seleccionar.`,
                    type: "400",
                });
                // Restablece el valor anterior de manera reactiva
                this.$nextTick(() => {
                    this.itemDataSelected.tipcontacto = '';
                });
                return;
            }
            // Actualiza los valores si no hay duplicados
            this.itemDataSelected.tipcontacto = value.tcnt_id;
            this.itemDataSelected.destipcontacto = tipoSeleccionado;
        },
        onChangeTipTel() {
            this.getTipoTelefono({ datoComun: 'obtenerTiposTelefono' })
        },
        selectTipoCarrier(value) {
            this.itemDataSelected.idcarrier = value.id
            this.itemDataSelected.destipcarrier = value.descarrier
        },

        //Rellena el campo de 'descripcion de tipo' con el 'id del tipo' que corresponde
        buscarPorTipContacto() {
            for (let i = 0; i < this.tipoContacto.length; i++) {
                if (this.tipoContacto[i].tcnt_id == this.itemDataSelected.tipcontacto) {
                    this.itemDataSelected['destipcontacto'] = this.tipoContacto[i].tcnt_des_tipcontacto
                }
            }
        },

        //Rellena el campo de 'descripcion de carrier' con el 'id del carrier' que corresponde
        buscarPorTipCarrier() {
            for (let i = 0; i < this.tipoCarrier.length; i++) {
                if (this.itemDataSelected.idcarrier == this.tipoCarrier[i].id)
                    this.itemDataSelected['destipcarrier'] = this.tipoCarrier[i].descarrier
            }
        },
        //Rellena el campo de 'codpais' con el 'idpais' que corresponde
        buscarIdPais() {
            for (let i = 0; i < this.codigoPais.length; i++) {
                if (this.itemDataSelected['codpais'] == this.codigoPais[i].prefijo) {
                    this.itemDataSelected['idpais'] = this.codigoPais[i].id
                }
            }
        },

        buscarTipoTel() {
            for (let i = 0; i < this.itemTipTel.length; i++) {
                if (this.itemDataSelected['tiptelefono'] == this.itemTipTel[i].id) {
                    this.itemDataSelected['destiptelefono'] = this.itemTipTel[i].nombre
                }
            }
        },
        formatoYValidacion() {
            if (this.datosContacto.telefono.carac.length + this.datosContacto.telefono.telefono.length !== 10) {
                this.showSnack({
                    message: 'La totalidad del número telefonico (prefijo y número) debe ser igual a 10 caractéres.',
                    type: '400'
                })
            }
        },

        /**
         * Valida y envía el formulario de teléfono.
         * Si es modificación, actualiza el teléfono principal según corresponda.
         * Si es alta, marca como principal si es el único o si se selecciona como tal.
         */
        async submit() {
            const isValid = await this.$refs.obs.validate();
            if (!isValid) {
                this.showSnack({
                    message: `Error al intentar guardar contacto.`,
                    type: "400",
                });
                return;
            }
            this.itemDataSelected.nroafi = this.nroafi;

            // Función auxiliar para desmarcar teléfonos principales
            const desmarcarPrincipales = () => {
                const aux = this.telefono
                    .filter(e => e.id !== this.itemDataSelected.id)
                    .map(e => ({ ...e, recibellamada: 0, accion: "M" }));
                aux.forEach(tel => this.sendTelefono(tel));
            };

            if (this.accion === 'modificar') {
                if (this.itemDataSelected.recibellamada == 1) {
                    desmarcarPrincipales();
                } else if (this.telefono.length === 0) {
                    this.itemDataSelected.recibellamada = 1;
                } else {
                    this.itemDataSelected.recibellamada = 1;
                }
                this.sendTelefono(this.itemDataSelected);
            } else {
                // Alta de teléfono
                if (this.telefono.length === 0) {
                    this.itemDataSelected.recibellamada = 1;
                } else if (this.itemDataSelected.recibellamada == 1) {
                    // Si se marca como principal, desmarcar los demás
                    const aux = this.telefono.map(e => ({ ...e, recibellamada: 0, accion: "M" }));
                    aux.forEach(tel => this.sendTelefono(tel));
                } else {
                    this.itemDataSelected.recibellamada = 0;
                }
                this.sendTelefono(this.itemDataSelected);
            }
            // Cierra el formulario/modal
            this.$emit('close');
        },
    },
    props: {
        accion: {
            type: String,
            required: true,
        },
    }
}

</script>